import { getControlItem, togglePlayPause } from '../utils/helpers'
import { BUTTON_ICON_CLASS, PLAY_VIDEO_BUTTON_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class PlayBigButton extends Controls {
  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderPlayBigButton()
  }

  private renderPlayBigButton() {
    this.wrapperElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [PLAY_VIDEO_BUTTON_CLASS],
          attributes: {
            ['data-dm']: 'button.play-video',
          },
        },
        children: [{ element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--play', 'icon--md'] }],
        eventListeners: ['click'],
        callback: () => togglePlayPause(this.videoPlayer, this.wrapperElement),
      }),
    )
  }
}
